import serviceInterceptor from '../../../services/ServiceInterceptor';

export const getAvailableRebates = (memberId: number) => serviceInterceptor(`/members/${memberId}/rebate-funds`);
